'use client';

import dynamic from 'next/dynamic';

const Sidebar = dynamic(() => import('@/components/flat-dashboard-sidebar'), { ssr: false });

/**
 * The single app sidebar (grouped sections: Beranda, Sumber Hukum, AI,
 * Workspace, ...). Previously switched between legacy and flat variants;
 * the legacy sidebar is gone, so this renders the sidebar directly.
 *
 * All layout files import this component instead of a sidebar directly.
 */
export default function NavigationSidebar() {
  return <Sidebar />;
}
